import {useState, useEffect} from 'react';
import axios from 'axios';
import {transformV1BrandingToV2} from './utils';

const shipmentTrackingUrlWithId = (id) => `${process.env.REACT_APP_API_URL}track/${id}`;

const shipmentTrackingUrlWithQueryParams = args => {
    const query = `branding_id=${args.branding_id}&carrier_code=${args.carrier_code}&tracking_number=${args.tracking_number}&order_number=${args.order_number}&postal_code=${args.postal_code}&shipment_id=${args.shipment_id}`;
    return `${process.env.REACT_APP_API_URL}track/?${query}`;
};


function originIsSafe(origin) {
    // probably need to revisit this regex as it continues to grow
    return  process.env.NODE_ENV === 'test' ||
        origin.match(/localhost:[0-9]+/) ||
        origin.match(/\.shippingeasy\.com$/) ||
        origin.match(/\.shipstation\.com$/) ||
        origin.match(/\.stamps\.com$/) ||
        origin.match(/\.endicia\.com$/) ||
        origin.match(/\.goglobalpost\.com$/);
}

export default function useShipmentTrackingData(trackingArgs) {
    const trackingUrl = trackingArgs.id ?
        shipmentTrackingUrlWithId(trackingArgs.id) :
        shipmentTrackingUrlWithQueryParams(trackingArgs);

    const {isPreview, mockPreviewData} = {...trackingArgs};

    const [state, setState] = useState({branding: {}, loaded: false});
    const [error, setError] = useState();

    useEffect(() => {
        if (isPreview) {
            // This path will never get reloaded if preview changes so don't put transforms for preview data here.
            // This code is only here to mimick having loaded the tracking data (preview data changes happen on `previewData`).
            setState({ ...mockPreviewData, loaded: true });
        } else {
            axios.get(trackingUrl).then(
                (response) => {
                    const {data} = response;
                    if (data.shipment) {
                        data.shipment.carrier_code = data.shipment.carrier_code.toLowerCase();
                    }
                    data.loaded = true;
                    setState(data);
                },
            ).catch(
              (error) => {
                setError(error);
              }
            );
        }
    }, [trackingUrl, mockPreviewData, isPreview]);

    const [previewData, setPreview] = useState(() => ({
        previewListener: window.addEventListener('message', (msg) => {
            if (originIsSafe(msg.origin) && msg.data.source === 'branded-tracking-preview') {
                const { branding, notification_setting, preview } = msg?.data;
                setPreview({ branding, notification_setting, preview });
                console.debug && console.debug("Preview payload:", msg?.data);
            }
        }),
    }));

    // NB - if we ever need to return a `setState` here this whole process will need to be rethought
    return [{
        ...state,
        branding: transformV1BrandingToV2({
            ...state.branding,
            ...previewData.branding,
        }),
        notification_setting: {
            ...state.notification_setting,
            ...previewData.notification_setting
        },
        preview: {
            isPreview,
            ...(previewData.preview || {})
        }
    }, error, setState];
}
